import { PRODUCT_UPDATE_LIBRARY } from 'modules/product/store/constants';

export const updateProductsLibraryAction = (list) => (dispatch) => {
  dispatch({ type: PRODUCT_UPDATE_LIBRARY, payload: list });
};
